import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/common/layout/layout';
import SEO from '../components/common/seo/seo';

const Home = ({ data, location }) => {
    const title = data.site.siteMetadata.title;
    const keywords = [
        `frontend engineer`,
        `ignacio villamar`,
        `villamar`,
        `javascript`,
        `developer`,
        `react`,
        `software engineer`,
        `ivstudio`
    ];
    return (
        <Layout location={location} title={title}>
            <SEO title="Web Development" keywords={keywords} />
        </Layout>
    );
};

export default Home;
export const pageQuery = graphql`
    query {
        site {
            siteMetadata {
                title
            }
        }
    }
`;
